export default function (v) {
  if (!v) return ''
  v = v.replace(/q/g, 'й')
  v = v.replace(/w/g, 'ц')
  v = v.replace(/e/g, 'у')
  v = v.replace(/r/g, 'к')
  v = v.replace(/t/g, 'е')
  v = v.replace(/y/g, 'н')
  v = v.replace(/u/g, 'г')
  v = v.replace(/i/g, 'ш')
  v = v.replace(/o/g, 'щ')
  v = v.replace(/p/g, 'з')
  v = v.replace(/\[/g, 'х')
  v = v.replace(/\]/g, 'ъ')
  v = v.replace(/a/g, 'ф')
  v = v.replace(/s/g, 'ы')
  v = v.replace(/d/g, 'в')
  v = v.replace(/f/g, 'а')
  v = v.replace(/q/g, 'п')
  v = v.replace(/h/g, 'р')
  v = v.replace(/j/g, 'о')
  v = v.replace(/k/g, 'л')
  v = v.replace(/l/g, 'д')
  v = v.replace(/;/g, 'ж')
  v = v.replace(/\'/g, 'э')
  v = v.replace(/z/g, 'я')
  v = v.replace(/x/g, 'ч')
  v = v.replace(/c/g, 'с')
  v = v.replace(/v/g, 'м')
  v = v.replace(/b/g, 'и')
  v = v.replace(/n/g, 'т')
  v = v.replace(/m/g, 'ь')
  v = v.replace(/,/g, 'б')
  v = v.replace(/\./g, 'ю')
  v = v.replace(/`/g, 'ё')

  v = v.replace(/Q/g, 'Й')
  v = v.replace(/W/g, 'Ц')
  v = v.replace(/E/g, 'У')
  v = v.replace(/R/g, 'К')
  v = v.replace(/T/g, 'Е')
  v = v.replace(/Y/g, 'Н')
  v = v.replace(/U/g, 'Г')
  v = v.replace(/I/g, 'Ш')
  v = v.replace(/O/g, 'Щ')
  v = v.replace(/P/g, 'З')
  v = v.replace(/\{/g, 'Х')
  v = v.replace(/\}/g, 'Ъ')

  v = v.replace(/A/g, 'Ф')
  v = v.replace(/S/g, 'Ы')
  v = v.replace(/D/g, 'В')
  v = v.replace(/F/g, 'А')
  v = v.replace(/G/g, 'П')
  v = v.replace(/H/g, 'Р')
  v = v.replace(/J/g, 'О')
  v = v.replace(/K/g, 'Л')
  v = v.replace(/L/g, 'Д')
  v = v.replace(/\:/g, 'Ж')
  v = v.replace(/\"/g, 'Э')

  v = v.replace(/Z/g, 'Я')
  v = v.replace(/X/g, 'Ч')
  v = v.replace(/C/g, 'С')
  v = v.replace(/V/g, 'М')
  v = v.replace(/B/g, 'И')
  v = v.replace(/N/g, 'Т')
  v = v.replace(/M/g, 'Ь')
  v = v.replace(/\</g, 'Б')
  v = v.replace(/\>/g, 'Ю')
  v = v.replace(/~/g, 'Ё')
  return v
}
